/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Update_StoryInputs */

const en_story_bank_update_story = /** @type {(inputs: Story_Bank_Update_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Story`)
};

const de_story_bank_update_story = /** @type {(inputs: Story_Bank_Update_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Story`)
};

const fr_story_bank_update_story = /** @type {(inputs: Story_Bank_Update_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Story`)
};

const es_story_bank_update_story = /** @type {(inputs: Story_Bank_Update_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Story`)
};

const it_story_bank_update_story = /** @type {(inputs: Story_Bank_Update_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Story`)
};

const nl_story_bank_update_story = /** @type {(inputs: Story_Bank_Update_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Story`)
};

const pl_story_bank_update_story = /** @type {(inputs: Story_Bank_Update_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Story`)
};

const fi_story_bank_update_story = /** @type {(inputs: Story_Bank_Update_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Story`)
};

const da_story_bank_update_story = /** @type {(inputs: Story_Bank_Update_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Story`)
};

const sv_story_bank_update_story = /** @type {(inputs: Story_Bank_Update_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Story`)
};

/**
* | output |
* | --- |
* | "Update Story" |
*
* @param {Story_Bank_Update_StoryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_update_story = /** @type {((inputs?: Story_Bank_Update_StoryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Update_StoryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_update_story(inputs)
	if (locale === "fr") return fr_story_bank_update_story(inputs)
	if (locale === "es") return es_story_bank_update_story(inputs)
	if (locale === "it") return it_story_bank_update_story(inputs)
	if (locale === "nl") return nl_story_bank_update_story(inputs)
	if (locale === "pl") return pl_story_bank_update_story(inputs)
	if (locale === "fi") return fi_story_bank_update_story(inputs)
	if (locale === "da") return da_story_bank_update_story(inputs)
	if (locale === "sv") return sv_story_bank_update_story(inputs)
	return en_story_bank_update_story(inputs)
});